module.exports = __webpack_public_path__ + "static/img/self_cloud.a48f5d70.svg";